import { stopScrolling, startScrolling } from '../alpine-functions';

const MODAL_CONTENT = 'modal-content';
const VIDEO_CONTENT_SOURCE = 'vimeo.com';

export default (target) => ({
  originContent: '',
  contentElement: null,
  modal: null,
  target: target,
  size: null,
  spinner: document.getElementById('alpine-modal-spinner'),
  close: document.getElementById('alpine-modal-close'),

  init() {
    this.modal = document.getElementById(target);
    if (this.$el.dataset.size !== undefined) {
      this.size = this.$el.dataset.size;
    }
  },

  get modalSize() {
    return `alpine-modal--${this.size}`;
  },

  handleModal() {
    const source = this.$el.dataset.source;
    if (source && this.modal) {
      this.modal.classList.add('alpine-modal--loading');
      const targetContent = this.modal.querySelector('.alpine-modal__content');
      this.showSpinner();
      if (source.indexOf('#') === 0) {
        this.getContent(source, targetContent);
      } else if (source === VIDEO_CONTENT_SOURCE) {
        if (this.$el.href.indexOf(VIDEO_CONTENT_SOURCE) !== -1) {
          this.getVimeoPlayer(this.$el.href, targetContent);
        } else {
          this.closeModal();
          window.open(this.$el.href);
        }
      } else {
        this.getData(source, targetContent);
      }
    }
  },

  openModal() {
    stopScrolling();
    this.modal.classList.remove('alpine-modal--loading');
    this.close.classList.remove('alpine-modal__close--hidden');
    this.modal.classList.add(this.modalSize);
    this.modal.classList.add('alpine-modal--open');
  },

  removeOuterElements() {
    // TODO: refactor complexity
    const modalContent = document.getElementById(MODAL_CONTENT).outerHTML;
    const targetContent = this.modal.querySelector('.alpine-modal__content');
    targetContent.innerHTML = '';
    targetContent.innerHTML = modalContent;
  },

  closeModal() {
    this.modal.classList.remove('alpine-modal--loading');
    this.modal.classList.remove('alpine-modal--open');
    this.spinner.classList.add('spinner-border--hidden');
    this.close.classList.add('alpine-modal__close--hidden');
    startScrolling();
    this.revertContent();
  },

  showSpinner() {
    setTimeout(() => {
      if (
        this.spinner &&
        this.spinner.classList.contains('spinner-border--hidden')
      ) {
        this.spinner.classList.remove('spinner-border--hidden');
      }
    }, 100);
  },

  getData(source, target) {
    fetch(source)
      .then((response) => response.text())
      .then((html) => {
        target.innerHTML = html;
        this.removeOuterElements();
      })
      .then(() => {
        this.openModal();
      });
  },

  getContent(source, target) {
    this.contentElement = document.getElementById(source.substring(1));
    if (this.contentElement.dataset.disableAlpine == 'true') {
      this.originContent = `<div x-ignore>${this.contentElement.innerHTML}</div>`;
    } else {
      this.originContent = this.contentElement.innerHTML;
    }
    this.handleContent(target);
    this.openModal();
  },

  getVimeoPlayer(linkToVideo, target) {
    if (linkToVideo.includes(VIDEO_CONTENT_SOURCE)) {
      const id = linkToVideo.substr(
        linkToVideo.indexOf(VIDEO_CONTENT_SOURCE) +
          VIDEO_CONTENT_SOURCE.length +
          1
      );
      target.innerHTML = `<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/${id}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe></div>`;
    } else {
      target.innerHTML =
        '<div style="padding:56.25% 0 0 0;position:relative;"><h3 style="position:absolute;top:50%;width:100%;transform:translateY(-50%)" class="text-center">Video se nepodařilo načíst, zkontrolujte prosím platnost adresy videa</h3></div>';
    }
    this.openModal();
  },

  revertContent() {
    if (this.contentElement !== null) {
      this.contentElement.innerHTML = this.originContent;
      this.originContent = '';
    } else {
      this.modal.querySelector('.alpine-modal__content').innerHTML = '';
    }
  },

  handleContent(target) {
    this.contentElement.innerHTML = '';
    target.innerHTML = this.originContent;
  },
});
